<app-anonymous-page-layout>
  <app-card>
    <app-page-title
      [title]="'PAGE.ONBOARDING_CREATOR.TITLE' | translate"
      style="--page-title-padding-bottom: var(--size-xl)"
    ></app-page-title>
    <form [formGroup]="form" (ngSubmit)="register()" class="form-layout">
      <app-form-element
        class="item -half"
        [label]="'LABEL.FIRSTNAME' | translate"
        inputId="firstname"
        [errors]="formHelper.getErrors('firstname')"
      >
        <mat-form-field>
          <input matInput id="firstname" required [formControl]="form.controls.firstname" />
        </mat-form-field>
      </app-form-element>
      <app-form-element
        class="item -half"
        [label]="'LABEL.LASTNAME' | translate"
        inputId="lastname"
        [errors]="formHelper.getErrors('lastname')"
      >
        <mat-form-field>
          <input matInput id="lastname" required [formControl]="form.controls.lastname" />
        </mat-form-field>
      </app-form-element>
      <app-form-element
        class="item"
        [label]="'LABEL.PHONE' | translate"
        inputId="phoneNumber"
        [errors]="formHelper.getErrors('phoneNumber')"
      >
        <mat-form-field>
          <input matInput id="phoneNumber" type="tel" required [formControl]="form.controls.phoneNumber" />
        </mat-form-field>
      </app-form-element>
      <app-form-element
        class="item"
        [label]="'LABEL.BIRTHDATE' | translate"
        inputId="birthdate"
        [errors]="formHelper.getErrors('birthdate')"
        [description]="'PAGE.ONBOARDING_CREATOR.MIN_AGE' | translate"
      >
        <mat-form-field>
          <input matInput id="birthdate" type="date" required [formControl]="form.controls.birthdate" />
          <button mat-icon-button matSuffix type="button">
            <app-icon name="calendar"></app-icon>
          </button>
        </mat-form-field>
      </app-form-element>
      <app-form-element class="item" [label]="'LABEL.EMAIL' | translate" inputId="email" [errors]="formHelper.getErrors('email')">
        <mat-form-field>
          <input matInput id="email" required [formControl]="form.controls.email" />
        </mat-form-field>
      </app-form-element>
      <app-form-element class="item" inputId="termsAccepted" label="" [errors]="formHelper.getErrors('termsAccepted')">
        <mat-checkbox [formControl]="form.controls.termsAccepted">
          <div [innerHTML]="'LABEL.ACCEPT_TERMS' | translate"></div>
        </mat-checkbox>
      </app-form-element>
      <div class="actions">
        <app-button [label]="'LABEL.CREATE_ACCOUNT' | translate" [disabled]="isSaving" [stretched]="true"></app-button>
      </div>
    </form>
  </app-card>
</app-anonymous-page-layout>
